/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * An administrator of an event with the name fields the UI lists.
 * @export
 * @interface EventAdministratorRead
 */
export interface EventAdministratorRead {
    /**
     * 
     * @type {string}
     * @memberof EventAdministratorRead
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof EventAdministratorRead
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof EventAdministratorRead
     */
    first_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventAdministratorRead
     */
    last_name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EventAdministratorRead
     */
    added_at: Date;
}

/**
 * Check if a given object implements the EventAdministratorRead interface.
 */
export function instanceOfEventAdministratorRead(value: object): value is EventAdministratorRead {
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('added_at' in value) || value['added_at'] === undefined) return false;
    return true;
}

export function EventAdministratorReadFromJSON(json: any): EventAdministratorRead {
    return EventAdministratorReadFromJSONTyped(json, false);
}

export function EventAdministratorReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventAdministratorRead {
    if (json == null) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
        'username': json['username'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'added_at': (new Date(json['added_at'])),
    };
}

export function EventAdministratorReadToJSON(json: any): EventAdministratorRead {
    return EventAdministratorReadToJSONTyped(json, false);
}

export function EventAdministratorReadToJSONTyped(value?: EventAdministratorRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['user_id'],
        'username': value['username'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'added_at': ((value['added_at']).toISOString()),
    };
}

